import { repositoryActions } from "./repository";

export const repository_actions = {
  ...repositoryActions
};
export { default as repositorySlice } from "./repository";
